import {
  Banknote,
  Building2,
  ChartColumnDecreasing,
  CircleDollarSign,
  MessageCircle,
  ReceiptText,
  TicketPlus,
  Users,
  WalletCards,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

import { ROUTES } from "./routes";
import type { AvailableMerchant } from "../types/types";

export type NavItem = { path: string; section: string; icon: LucideIcon };

/**
 * Org context consolidates, so it carries only the screens that can: recaudo
 * across the portfolio, the bills for every building in it, and the buildings
 * themselves. Same slot and styling as the merchant nav — just a shorter list.
 */
export const orgNav = ({ isOrgAdmin }: { isOrgAdmin: boolean }): NavItem[] => [
  {
    path: ROUTES.DASHBOARD.HOME,
    section: "Resumen",
    icon: ChartColumnDecreasing,
  },
  {
    path: ROUTES.DASHBOARD.BILLING,
    section: "Facturación",
    icon: ReceiptText,
  },
  ...(isOrgAdmin
    ? [
        {
          path: ROUTES.DASHBOARD.MERCHANTS,
          section: "Comercios",
          icon: Building2,
        },
      ]
    : []),
];

export const merchantNav = (
  merchant: AvailableMerchant | undefined
): NavItem[] => [
  {
    path: ROUTES.DASHBOARD.HOME,
    section: "Resumen",
    icon: ChartColumnDecreasing,
  },
  {
    path: ROUTES.DASHBOARD.CUSTOMERS,
    section: "Clientes",
    icon: Users,
  },
  {
    path: ROUTES.DASHBOARD.INVOICES,
    section: "Recaudos",
    icon: CircleDollarSign,
  },
  {
    path: ROUTES.DASHBOARD.SETTLEMENTS,
    section: "Conciliación",
    icon: WalletCards,
  },
  {
    path: ROUTES.DASHBOARD.WHATSAPP,
    section: "WhatsApp",
    icon: MessageCircle,
  },
  ...(merchant?.subscriptionConfig?.enabled
    ? [
        {
          path: ROUTES.DASHBOARD.SUBSCRIPTIONS,
          section: "Suscripciones",
          icon: TicketPlus,
        },
      ]
    : []),
  ...(merchant?.payoutsConfig
    ? [
        {
          path: ROUTES.DASHBOARD.PAYOUTS,
          section: "Pagos",
          icon: Banknote,
        },
      ]
    : []),
  ...(merchant
    ? [
        {
          path: ROUTES.DASHBOARD.BILLING,
          section: "Facturación",
          icon: ReceiptText,
        },
      ]
    : []),
];
